<template>
  <div class="external-score-entry">
    <el-dialog
      :visible.sync="externalScoreEntryShow"
      width="800px"
      :before-close="dialogClose"
      @open="dialogOpen"
    >
      <div class="title" slog="title">
        <span>校外成绩录入(平均分)</span>
        <i class="icon el-icon-circle-plus-outline" @click="addData"></i>
        <i class="icon el-icon-remove-outline" @click="delData"></i>
      </div>
      <div class="score-entry-dialog">
        <el-form ref="form" label-width="80px">
          <el-form-item>
            校外标识
            <el-input
              class="campus-sign"
              placeholder="请输入校外标识"
              v-model="outsideSchoolSign"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            v-for="(item, index) in dataList"
            :key="index"
            :inline="true"
            :model="item"
          >
            <el-col :span="10">
              <span style="width: 50px; margin-right: 5px">科目</span>
              <el-select v-model="item.courseId" placeholder="请选择">
                <el-option
                  v-for="sItem in schoolCourseList"
                  :key="sItem.courseId"
                  :label="sItem.courseName"
                  :value="sItem.courseId"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="11" style="display: flex">
              <span style="width: 50px; margin-right: 5px">平均分</span>
              <el-input
                v-model.number="item.avgScore"
                placeholder="请输入"
                prop="rank"
                type="number"
                :min="1"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-list">
        <div class="btn define" @click="confirm">确定</div>
        <div class="btn cancel" @click="dialogClose">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["externalScoreEntryShow", "schoolCourseList"],
  data() {
    return {
      outsideSchoolSign: "", // 校外标识
      dataList: [
        {
          courseId: "",
          avgScore: "",
        },
      ],
    };
  },
  methods: {
    // 校外成绩录入点击确定
    confirm() {
      // console.log(
      //   "校外成绩录入点击确定",
      //   this.outsideSchoolSign,
      //   this.dataList
      // );
      let data = {
        outsideSchoolSign: this.outsideSchoolSign,
        avgScores: this.dataList,
      };
      this.$emit("externalScoreEntryConfirm", data);
    },
    dialogOpen() {
      this.outsideSchoolSign = "";
      this.dataList = [
        {
          courseId: "",
          avgScore: "",
        },
      ];
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:externalScoreEntryShow", false);
    },
    // 添加一行数据
    addData() {
      this.dataList.push({
        courseId: "",
        avgScore: "",
      });
    },
    // 删除一行数据
    delData() {
      if (this.dataList.length == 1)
        return this.$message.warning("至少存在一条数据！");
      this.dataList.pop();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./externalScoreEntryDialog.scss";
</style>